var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page lenta",staticStyle:{"padding-top":"15px"}},[_c('Pins',{attrs:{"loading":_vm.loading,"loading_more":_vm.loading_more,"pins":_vm.pins,"adder":true}}),_c('ModalPhotos'),(_vm.active)?_c('ModalPin',{attrs:{"pin":_vm.active},on:{"clear":function($event){_vm.active = null}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }